import { createDraftsStore } from '@discovr/features';

/**
 * Persisted, UID-scoped brand campaign drafts.
 * Created via createDraftsStore so the localStorage key is role-namespaced
 * (`discovr-brand-campaign-drafts-{uid}`) and separate from admin drafts.
 */
export const useBrandDraftsStore = createDraftsStore('brand');
